export const CADENCE_TYPE_ABSOLUTE = 'ABSOLUTE';
export const CADENCE_TYPE_RELATIVE = 'RELATIVE';
export const DOC_TYPE_GUIDE = 'GUIDE';
export const DOC_TYPE_WIKI = 'WIKI';
